import LoginForm from "@/features/login/components/LoginForm";
import { ThemeToggle } from "@/shared/components/ui/themeToggle";
import { useCurrentUser } from "@/features/login/hooks/useCurrentUser";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import logo from "@/assets/LOGO-RETRO-IA.png";

export function LoginPage() {
  const { user } = useCurrentUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user.rol?.nombre) {
      switch (user.rol.nombre) {
        case "APRENDIZ":
          navigate("/programas", { replace: true });
          break;
        default:
          navigate("/", { replace: true });
      }
    }
  }, [user, navigate]);

  return (
    <div
      className="flex h-screen items-center justify-center bg-gradient-to-b"
      style={{
        backgroundImage:
          "linear-gradient(to bottom, var(--linear-gradient-start), var(--linear-gradient-end))",
      }}
    >
      <div className="absolute top-4 right-4">
        <ThemeToggle />
      </div>
      <div
        className="min-h-screen flex items-center justify-center px-3 sm:px-4 md:px-6 shadow-xl"
        style={{
          background: `radial-gradient(circle at top right, var(--linear-gradient-end), var(--linear-gradient-start) 40%)`,
        }}
      >
        <div className="min-h-screen w-full max-w-2xl flex items-start justify-center px-4 sm:px-8 md:px-12 lg:px-20 pt-[10vh]">
          <div className="flex flex-col w-full max-w-md">
            <div className="m-6 sm:m-8 md:m-10 flex justify-center">
              <img
                src={logo}
                alt="Logo Retro IA"
                className="h-auto w-40 sm:w-50"
              />
            </div>
            <div className="flex justify-center px-1 mb-5">
              <p className="text-center text-sm sm:text-base">
                Aquí llevarás a la práctica lo que aprendiste y recibirás
                retroalimentación personalizada.
              </p>
            </div>
            <LoginForm />
            <div className="flex justify-center items-end mt-8">
              <span className="text-xs sm:text-sm">POWER BY INTELEGO</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
